import React from "react";
import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import { RouteComponentProps } from "react-router-dom";
import { BenefitsCMSPage } from "./BenefitsCMSPage";
import { useQueryCMSWebflowBenefit } from "../../../query/cms/queries";
import { WSQueries } from "../../../query/WSQuery";
import { getParentPath } from "../../../utils/goToParentRoute";
import { getMeridioHealthInsuranceBenefit } from "../components/customBenefits/Meridio/getMeridioHealthInsuranceBenefit";
import { getPGLIBenefitDetails } from "../components/customBenefits/PGLI/getPGLIBenefitDetails";
import { BenefitsInsurancePage } from "./BenefitsInsurancePage";
import { getOAIBenefitDetails } from "../components/customBenefits/OAI/getOAIBenefitDetails";
import { useUserId } from "../../../query/hooks/helpers";
import { getBenefitsTabPathname } from "../paths";
import { BenefitsInsuranceTab } from "./RouteBenefitsInsurance/contsants";
import { MERIDIO_KEY, OAI_KEY, PGLI_KEY } from "../utils/constants";
import { customizeBenefit } from "../selectors/selectorBenefitsList";

type IPlanType = planEnrollmentApiSpec.PlanEnrollment["planType"];

export const RouteBenefitDetails: React.FC<
  RouteComponentProps<
    {
      tab: BenefitsInsuranceTab;
      benefit: string;
    },
    {},
    {}
  >
> = ({ match, history }) => {
  const userId = useUserId();

  const isDefaultCMSBenefit = ![PGLI_KEY, OAI_KEY, MERIDIO_KEY].includes(
    match.params.benefit
  );

  const isMeridioHealthInsurance = match.params.benefit === MERIDIO_KEY;
  const isOAIInsurance = match.params.benefit === OAI_KEY;
  const isPlInsurance = match.params.benefit === PGLI_KEY;

  const currentPlanType: IPlanType = isOAIInsurance
    ? "WingspanOccupationalAccidentInsurance"
    : "WingspanProfessionalLiabilityAndGeneralLiabilityInsurance";

  const qCMSWebflowBenefit = useQueryCMSWebflowBenefit(match.params.benefit, {
    enabled: isDefaultCMSBenefit
  });

  const parentPath = getParentPath(history);

  if (isMeridioHealthInsurance) {
    const benefit = getMeridioHealthInsuranceBenefit();

    return <BenefitsCMSPage parentPath={parentPath} isFree benefit={benefit} />;
  } else if (isOAIInsurance || isPlInsurance) {
    return (
      <BenefitsInsurancePage
        parentPath={getBenefitsTabPathname(match.params.tab)}
        planType={currentPlanType}
        insurance={
          isOAIInsurance ? getOAIBenefitDetails() : getPGLIBenefitDetails()
        }
      />
    );
  } else {
    return (
      <WSQueries queries={{ qCMSWebflowBenefit }}>
        {({ qCMSWebflowBenefitData }) => {
          const benefit = customizeBenefit(qCMSWebflowBenefitData);

          return <BenefitsCMSPage parentPath={parentPath} benefit={benefit} />;
        }}
      </WSQueries>
    );
  }
};
